define(
//begin v1.x content
({
	loadingState: "Laadimine...",
	errorState: "Kahjuks ilmnes viga"
})
//end v1.x content
);
